import { render, staticRenderFns } from "./UserExamAppHeaderExtension.vue?vue&type=template&id=0a4a163d&"
import script from "./UserExamAppHeaderExtension.vue?vue&type=script&lang=ts&"
export * from "./UserExamAppHeaderExtension.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
